module.exports = __webpack_public_path__ + "img/9788983782656.05717cb8.jpg";